import { ID } from "@models/index";

export enum Metric {
    LoveIt = 1,
    LikeIt = 2,
    Neutral = 3,
    Dislike = 4,
    HateIt = 5,
    KnowIt = 6,
    HaveTriedIt = 7,
    HadManyTimes = 8,
    LoveLikeIt = 10,
}

export enum DemographicGroup {
    Gender = 1,
    Generation = 2,
    Ethnicity = 3,
    Region = 4,
}

export enum KeywordRanking {
    ByMetric = 0,
    ByChange = 1,
}

export interface ConsumerTrendPoint {
    year: number;
    quarter: number;
    value: number;
}

export interface ConsumerKeyword {
    id: ID;
    name: string;
    trend: ConsumerTrendPoint[];
    twoYearChange: number;
}

export interface ConsumerDemographicCohort {
    id: ID;
    name: string;
    items: { name: string; index: number }[];
}

export interface ConsumerMetricData {
    topKeywords: ConsumerKeyword[];
    topKeywordsByChange: ConsumerKeyword[];
    demographics: Record<DemographicGroup, ConsumerDemographicCohort[]>;
}

export interface ConsumerData {
    hasCpCategories: boolean;
    byMetric: Record<Metric, ConsumerMetricData>;
}

export const CONSUMER_METRICS: Metric[] = [
    Metric.KnowIt,
    Metric.HaveTriedIt,
    Metric.HadManyTimes,
    Metric.LoveLikeIt,
    Metric.LoveIt,
    Metric.LikeIt,
    Metric.Neutral,
    Metric.Dislike,
    Metric.HateIt,
];
